import { render, staticRenderFns } from "./PlayerSearchOverview.vue?vue&type=template&id=7aaaf698"
import script from "./PlayerSearchOverview.vue?vue&type=script&lang=js"
export * from "./PlayerSearchOverview.vue?vue&type=script&lang=js"
import style0 from "./PlayerSearchOverview.vue?vue&type=style&index=0&id=7aaaf698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip,QIcon,QTable,QInnerLoading,QTh,QSpinner});
